import { render, staticRenderFns } from "./MessagePoolCell.vue?vue&type=template&id=770649b0&"
import script from "./MessagePoolCell.vue?vue&type=script&lang=js&"
export * from "./MessagePoolCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports